import { useContext, useMemo } from 'react';

import { SettingsContext } from '@/providers/SettingsProvider';

export const useCurrency = () => {
  const { settings } = useContext(SettingsContext);

  return useMemo(() => settings?.currency, [settings?.currency]);
};
